<template>
  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 7C7.933 7 9.5 5.433 9.5 3.5C9.5 1.567 7.933 0 6 0C4.067 0 2.5 1.567 2.5 3.5C2.5 5.433 4.067 7 6 7ZM6 15C9.31371 15 12 13.433 12 11.5C12 9.567 9.31371 8 6 8C2.68629 8 0 9.567 0 11.5C0 13.433 2.68629 15 6 15Z" fill="#D64633"/>
  </svg>
</template>